var LinkFontFamily;
(function (LinkFontFamily) {
    LinkFontFamily["BOLD"] = "bold";
    LinkFontFamily["MEDIUM"] = "medium";
})(LinkFontFamily || (LinkFontFamily = {}));
export { LinkFontFamily, };
//# sourceMappingURL=link-constants.js.map